// src/hooks/currencies/useUpdateCurrencies.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateCurrency } from "../../api/apiCurrencies";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

const useUpdateCurrencies = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const {
        mutate: editCurrencies,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: ({ id, req }) => updateCurrency(req, id),
        onSuccess: (response) => {
            toast.success(response?.message);
            navigate('/currencies');
            queryClient.invalidateQueries({ queryKey: ["currencies"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update currency");
        },
    });

    return {
        editCurrencies,
        isUpdate: isPending || isLoading,
    };
};

export default useUpdateCurrencies;
